// Consumers compile this file inside their own project, where the ambient window.Datarouter declaration is
// not otherwise in scope, so an import cannot replace this reference.
// oxlint-disable-next-line typescript/triple-slash-reference
/// <reference path="../declarations/global.d.ts" />
import { maybe } from 'true-myth';

// Read window.Datarouter on every call so config picks up whenever the injected
// page-source script runs, regardless of bundle/script load ordering.
export const datarouter = () => maybe.of(typeof window !== 'undefined' ? window.Datarouter : null);

const config = () => datarouter().andThen((datarouter) => maybe.of(datarouter.Config));

export const NUMBER = () => config().andThen((config) => maybe.of(config.Number));
export const STRING = () => config().andThen((config) => maybe.of(config.String));
export const BOOLEAN = () => config().andThen((config) => maybe.of(config.Boolean));
export const STRING_CSV = () => config().andThen((config) => maybe.of(config.StringCsv));
export const NUMBER_CSV = () => config().andThen((config) => maybe.of(config.NumberCsv));
